module.exports = __webpack_public_path__ + "img/solution-ct.726c5335.jpg";